import { Box, Container, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import useLanguage from 'src/hooks/Language/useLanguage';

const FooterWrapper = styled(Box)(
  ({ theme }) => `
        border-radius: 0;
        margin: ${theme.spacing(3)} 0;
`
);

function Footer() {
  const { language } = useLanguage();

  return (
    <FooterWrapper>
      <Container maxWidth="xl">
        <Box
          py={3}
          display={{ xs: 'block', md: 'flex' }}
          alignItems="center"
          textAlign={{ xs: 'center', md: 'left' }}
          justifyContent="space-between"
          padding={0}
          margin={0}
        >
          <Box>
            <Typography variant="subtitle1">&copy; {language.footer}</Typography>
          </Box>
        </Box>
      </Container>
    </FooterWrapper>
  );
}

export default Footer;
